import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/front/home/home.component';
import { MapaComponent } from './pages/front/mapa/mapa.component';
import { PedidoComponent } from './pages/front/pedido/pedido.component';
import { HorarioComponent } from './pages/front/horario/horario.component';
import { PagoComponent } from './pages/front/pago/pago.component';
import { ProductoComponent } from './pages/front/producto/producto.component';
import { CementoProductoComponent } from './pages/front/cemento/cemento-producto/cemento-producto.component';
import { CementoMapaComponent } from './pages/front/cemento/cemento-mapa/cemento-mapa.component';
import { CementoPagoComponent } from './pages/front/cemento/cemento-pago/cemento-pago.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HeaderComponent } from './shared/header/header.component';

import { ModalAlertComponent } from './shared/modal-alert/modal-alert.component';
import { ModalProductSelectionComponent } from './shared/modal-product-selection/modal-product-selection.component';
import { AdminNavComponent } from './shared/admin-nav/admin-nav.component';

import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LayoutModule } from '@angular/cdk/layout';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaModule, ReCaptchaV3Service } from 'ng-recaptcha-2';

import { ScheduleComponent } from './pages/admin/schedule/schedule.component';
import { SortableDirective } from './directives/sortable.directive';
import { AdminTableComponent } from './shared/admin-table/admin-table.component';
import { CotizacionComponent } from './pages/admin/cotizacion/cotizacion.component';
import { SalesComponent } from './pages/admin/sales/sales.component';
import { ContactsComponent } from './pages/admin/contacts/contacts.component';
import { SettingsComponent } from './pages/admin/settings/settings.component';
import { ShiftComponent } from './pages/admin/shift/shift.component';
import { PlantsComponent } from './pages/admin/plants/plants.component';
import { ComunaComponent } from './pages/admin/comuna/comuna.component';
import { RegionComponent } from './pages/admin/region/region.component';
import { SapComponent } from './pages/admin/sap/sap.component';
import { ExecutiveComponent } from './pages/admin/executive/executive.component';
import { LoginComponent } from './pages/admin/login/login.component';
import { ToastComponent } from './shared/toast/toast.component';
import { TableDataPipe } from './pipes/table-data.pipe';
import { DataTablesModule } from 'angular-datatables';
import {InputNumberModule} from 'primeng/inputnumber';
import { ComunaPlantaComponent } from './pages/admin/comuna-planta/comuna-planta.component';
import { UserComponent } from './pages/admin/user/user.component';
import { StepComponent } from './shared/step/step.component';
import { CheckoutAccordionSectionComponent } from './shared/checkout-accordion-section/checkout-accordion-section.component';
import { OrderSummarySidebarComponent } from './shared/order-summary-sidebar/order-summary-sidebar.component';
import { ProductDirectSelectComponent } from './shared/product-direct-select/product-direct-select.component';
import { ProductCardSelectComponent } from './shared/product-card-select/product-card-select.component';
import { RadioOptionGroupComponent } from './shared/radio-option-group/radio-option-group.component';
import { ItemDirectSelectComponent } from './shared/item-direct-select/item-direct-select.component';
import { CementoProductSectionComponent } from './pages/front/cemento/cemento-producto/cemento-product-section/cemento-product-section.component';
import { CementoCantidadServiciosSectionComponent } from './pages/front/cemento/cemento-producto/cemento-cantidad-servicios-section/cemento-cantidad-servicios-section.component';
import { CementoTipoEntregaSectionComponent } from './pages/front/cemento/cemento-producto/cemento-tipo-entrega-section/cemento-tipo-entrega-section.component';
import { CementoFechaServiciosSectionComponent } from './pages/front/cemento/cemento-producto/cemento-fecha-servicios-section/cemento-fecha-servicios-section.component';
import { CementoFacturacionSectionComponent } from './pages/front/cemento/cemento-producto/cemento-facturacion-section/cemento-facturacion-section.component';
import { ScheduleDatepickerComponent } from './shared/schedule-datepicker/schedule-datepicker.component';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbToastModule, NgbModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsModule } from '@angular/google-maps';
import { StoreService } from './services/store.service';
import { ResponsiveLayoutService } from './services/responsive-layout.service';
import { ReferralMetadataService } from './services/referral-metadata.service';
import { CommonService } from './services/common.service';
import { AuthenticationService } from './services/authentication.service';
import { ToastService } from './services/toast.service';
import { API_KEY } from './shared/utils/recaptcha';
import { CotizacionService } from './services/cotizacion.service';
import { ExcelService } from './services/excel.service';
import { RutService } from './services/rut.service';
import { StepService } from './services/step.service';
import { TableProviderService } from './services/table-provider.service';
import { ProductosComponent } from './pages/admin/productos/productos.component';
import { ProductPriceLogsComponent } from './pages/admin/product-price-logs/product-price-logs.component';
import { PoliticasEntregaPageComponent } from './pages/admin/cemento/pages/politicas-entrega/page/politicas-entrega-page.component';
import { PoliticasEntregaTablaComponent } from './pages/admin/cemento/pages/politicas-entrega/tabla/politicas-entrega-tabla.component';
import { CementoAdminMatrixTableComponent } from './pages/admin/cemento/shared/components/cemento-admin-matrix-table/cemento-admin-matrix-table.component';
import { PoliticaEntregaDetalleModalComponent } from './pages/admin/cemento/pages/politicas-entrega/components/politica-entrega-detalle-modal/politica-entrega-detalle-modal.component';
import { PoliticasEntregaCargaMasivaModalComponent } from './pages/admin/cemento/pages/politicas-entrega/components/politicas-entrega-carga-masiva-modal/politicas-entrega-carga-masiva-modal.component';
import { PoliticasEntregaConfirmDeleteModalComponent } from './pages/admin/cemento/pages/politicas-entrega/components/politicas-entrega-confirm-delete-modal/politicas-entrega-confirm-delete-modal.component';
import { ProductosCementoPageComponent } from './pages/admin/cemento/pages/productos/page/productos-cemento-page.component';
import { ProductosCementoTablaComponent } from './pages/admin/cemento/pages/productos/tabla/productos-cemento-tabla.component';
import { ProductoCementoDetalleModalComponent } from './pages/admin/cemento/pages/productos/components/producto-cemento-detalle-modal/producto-cemento-detalle-modal.component';
import { ProductosCementoCargaMasivaModalComponent } from './pages/admin/cemento/pages/productos/components/productos-cemento-carga-masiva-modal/productos-cemento-carga-masiva-modal.component';
import { DatosGeograficosCementoPageComponent } from './pages/admin/cemento/pages/datos-geograficos/page/datos-geograficos-cemento-page.component';
import { DatosGeograficosCementoTablaComponent } from './pages/admin/cemento/pages/datos-geograficos/tabla/datos-geograficos-cemento-tabla.component';
import { DatoGeograficoCementoDetalleModalComponent } from './pages/admin/cemento/pages/datos-geograficos/components/dato-geografico-cemento-detalle-modal/dato-geografico-cemento-detalle-modal.component';
import { DatosGeograficosCementoCargaMasivaModalComponent } from './pages/admin/cemento/pages/datos-geograficos/components/datos-geograficos-cemento-carga-masiva-modal/datos-geograficos-cemento-carga-masiva-modal.component';
import { CentrosLogisticosCementoPageComponent } from './pages/admin/cemento/pages/centros-logisticos/page/centros-logisticos-cemento-page.component';
import { CentrosLogisticosCementoTablaComponent } from './pages/admin/cemento/pages/centros-logisticos/tabla/centros-logisticos-cemento-tabla.component';
import { CentroLogisticoCementoDetalleModalComponent } from './pages/admin/cemento/pages/centros-logisticos/components/centro-logistico-cemento-detalle-modal/centro-logistico-cemento-detalle-modal.component';
import { CentrosLogisticosCementoCargaMasivaModalComponent } from './pages/admin/cemento/pages/centros-logisticos/components/centros-logisticos-cemento-carga-masiva-modal/centros-logisticos-cemento-carga-masiva-modal.component';
import { CbbSelectComponent } from './shared/cbb-select/cbb-select.component';
import { CbbButtonComponent } from './shared/cbb-button/cbb-button.component';
import { CbbFieldComponent } from './shared/cbb-field/cbb-field.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DigitsOnlyDirective } from './shared/directives/digits-only.directive';
import { CbbTableActionIconComponent } from './shared/cbb-table-action-icon/cbb-table-action-icon.component';
import { AdminServerTableComponent } from './pages/admin/cemento/shared/table/components/admin-server-table/admin-server-table.component';
import { CotizacionCementoPageComponent } from './pages/admin/cemento/pages/cotizacion/page/cotizacion-cemento-page.component';
import { CotizacionCementoTablaComponent } from './pages/admin/cemento/pages/cotizacion/tabla/cotizacion-cemento-tabla.component';
import { VentasCementoPageComponent } from './pages/admin/cemento/pages/ventas/page/ventas-cemento-page.component';
import { VentasCementoTablaComponent } from './pages/admin/cemento/pages/ventas/tabla/ventas-cemento-tabla.component';
import { ParametrosCementoPageComponent } from './pages/admin/cemento/pages/parametros/page/parametros-cemento-page.component';
import { ParametrosCementoTablaComponent } from './pages/admin/cemento/pages/parametros/tabla/parametros-cemento-tabla.component';
import { ParametroCementoEditModalComponent } from './pages/admin/cemento/pages/parametros/components/parametro-cemento-edit-modal/parametro-cemento-edit-modal.component';
import { EjecutivosCementoPageComponent } from './pages/admin/cemento/pages/ejecutivos/page/ejecutivos-cemento-page.component';
import { EjecutivosCementoTablaComponent } from './pages/admin/cemento/pages/ejecutivos/tabla/ejecutivos-cemento-tabla.component';
import { EjecutivoCementoDetalleModalComponent } from './pages/admin/cemento/pages/ejecutivos/components/ejecutivo-cemento-detalle-modal/ejecutivo-cemento-detalle-modal.component';
import { TextFieldMaskComponent } from './shared/text-field-mask/text-field-mask.component';
import { AdminAuthInterceptor } from './interceptors/admin-auth.interceptor';
import { ResumeComponent } from './pages/front/resume/resume.component';


export function initializeReferralMetadata(referralMetadataService: ReferralMetadataService): () => void {
  return () => {
    if (typeof globalThis === 'undefined' || !globalThis.window || !globalThis.window.location?.href) {
      return;
    }

    referralMetadataService.captureFromUrl(globalThis.window.location.href);
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MapaComponent,
    CementoMapaComponent,
    CementoPagoComponent,
    PedidoComponent,
    HorarioComponent,
    PagoComponent,
    FooterComponent,
    HeaderComponent,
    ProductoComponent,
    CementoProductoComponent,
    ModalAlertComponent,
    ModalProductSelectionComponent,
    AdminNavComponent,
    ScheduleComponent,
    SortableDirective,
    AdminTableComponent,
    CotizacionComponent,
    SalesComponent,
    ContactsComponent,
    SettingsComponent,
    ShiftComponent,
    PlantsComponent,
    ComunaComponent,
    RegionComponent,
    SapComponent,
    ExecutiveComponent,
    LoginComponent,
    ToastComponent,
    TableDataPipe,
    ComunaPlantaComponent,
    UserComponent,
    StepComponent,
    CheckoutAccordionSectionComponent,
    OrderSummarySidebarComponent,
    ProductDirectSelectComponent,
    ProductCardSelectComponent,
    RadioOptionGroupComponent,
    ItemDirectSelectComponent,
    CementoProductSectionComponent,
    CementoCantidadServiciosSectionComponent,
    CementoTipoEntregaSectionComponent,
    CementoFechaServiciosSectionComponent,
    CementoFacturacionSectionComponent,
    ScheduleDatepickerComponent,
    ProductosComponent,
    ProductPriceLogsComponent,
    PoliticasEntregaPageComponent,
    PoliticasEntregaTablaComponent,
    CementoAdminMatrixTableComponent,
    PoliticaEntregaDetalleModalComponent,
    PoliticasEntregaCargaMasivaModalComponent,
    PoliticasEntregaConfirmDeleteModalComponent,
    ProductosCementoPageComponent,
    ProductosCementoTablaComponent,
    ProductoCementoDetalleModalComponent,
    ProductosCementoCargaMasivaModalComponent,
    DatosGeograficosCementoPageComponent,
    DatosGeograficosCementoTablaComponent,
    DatoGeograficoCementoDetalleModalComponent,
    DatosGeograficosCementoCargaMasivaModalComponent,
    CentrosLogisticosCementoPageComponent,
    CentrosLogisticosCementoTablaComponent,
    CentroLogisticoCementoDetalleModalComponent,
    CentrosLogisticosCementoCargaMasivaModalComponent,
    CbbSelectComponent,
    CbbButtonComponent,
    CbbFieldComponent,
    DigitsOnlyDirective,
    CbbTableActionIconComponent,
    AdminServerTableComponent,
    CotizacionCementoPageComponent,
    CotizacionCementoTablaComponent,
    VentasCementoPageComponent,
    VentasCementoTablaComponent,
    ParametrosCementoPageComponent,
    ParametrosCementoTablaComponent,
    ParametroCementoEditModalComponent,
    EjecutivosCementoPageComponent,
    EjecutivosCementoTablaComponent,
    EjecutivoCementoDetalleModalComponent,
    ResumeComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    //HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxSpinnerModule,
    LayoutModule,
    RecaptchaModule,
    DataTablesModule,
    InputNumberModule,
    RouterModule,
    NgbDatepickerModule,
    NgbToastModule,
    GoogleMapsModule,
    NgSelectModule,
    TextFieldMaskComponent,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()) ,
    StoreService,
    ResponsiveLayoutService,
    NgbModal,
    NgxSpinnerService,
    ReCaptchaV3Service,
    CommonService,
    AuthenticationService,
    ToastService,
    CotizacionService,
    ExcelService,
    RutService,
    StepService,
    TableProviderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AdminAuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeReferralMetadata,
      deps: [ReferralMetadataService],
      multi: true
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: API_KEY }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
